import { Action } from '@ngrx/store';
import { Members } from '../models/team-members.model';

// Define a constant for the action type
export const ADD_MEMBER = 'ADD_MEMBER';

// Create a custom action class that extends the Action interface
export class AddMember implements Action {
    readonly type = ADD_MEMBER;
    constructor(public payload: Members) {}  // Add the payload property
}

// Define a union type for the actions that this reducer will handle
export type MemberActions = AddMember;

// The reducer function to manage state
export function memberReducer(state: Members[] = [], action: MemberActions) {
    switch (action.type) {
        case ADD_MEMBER:
            return [state.slice(), action.payload];

        default:
            return state;
    }
}
